export default "__VITE_ASSET__BC5g$_jX__"